import {
  GET_DISCUSIION_COURSEID_SUCCESS,
  GET_DISCUSIION_POST_COURSEID_SUCCESS,
  GET_DROPBOX_COURSEID_SUCCESS,
  GET_GRADEBOOK_ITEM_COURSEID_SUCCESS,
  RESET_DISCUSSIONS_DATA,
} from "../constants";

export const initialState = {
  discussion: undefined,
  post: undefined,
  dropbox: undefined,
  items: undefined,
};
export const StartEndDateReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_DISCUSIION_COURSEID_SUCCESS:
      return {
        ...state,
        discussion: action.payload,
      };
    case GET_DISCUSIION_POST_COURSEID_SUCCESS:
      return {
        ...state,
        post: action.payload,
      };
    case GET_DROPBOX_COURSEID_SUCCESS:
      return {
        ...state,
        dropbox: action.payload,
      };
    case GET_GRADEBOOK_ITEM_COURSEID_SUCCESS:
      return {
        ...state,
        items: action.payload,
      };
    case RESET_DISCUSSIONS_DATA:
      return {
        ...state,
        post: undefined,
        dropbox: undefined
      };
      
    default:
      return state;
  }
};
